import styled from 'styled-components';
import ZImage from 'sushiweb/ZImage/ZImage';

export const EmptyStateContainer = styled.div`
  width: calc(100vw - 27rem);
  position: absolute;
  top: 10rem;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8rem 0;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${props => (props.isEmployees ? '-50px' : '30px')};
  margin-bottom: 20px;
  p {
    color: var(--coolgreycoolgrey-600, #767c8f);
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    margin-top: 10px;
  }
  h4 {
    color: var(--coolgreycoolgrey-600, #767c8f);
    text-align: center;
    /* Advance/Light/Light 600 */
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    line-height: 26px; /* 130% */
  }
`;

export const ZImageWrapper = styled(ZImage)`
  width: 526.108px;
  height: 380.51px;
  flex-shrink: 0;
`;
